// assets
import WestBusinessLogo from "../../../assets/images/west-business-interiors-logo.svg";
import ImmigrationGroupLogo from "../../../assets/images/immigration group.svg";
import ChartwellLogo from "../../../assets/images/chartwell-logo.webp";
import FCLogo from "../../../assets/images/FClogo-compressed.2022_FC.Black_.compressed.logo_.png";
import GenesisLogo from "../../../assets/images/Genesis-Logo-1.png"
import NCFLLogo from "../../../assets/images/Layer_1-2.svg"
import e47Logo from "../../../assets/images/Frame10.svg"
import MSMALogo from "../../../assets/images/cropped-logo_red-2.webp"
import WiredHumanLogo from "../../../assets/images/wired-human.svg"
import SwanLogo from "../../../assets/images/swan.png"
import LLLogo from "../../../assets/images/LLeigh.svg"
import DDLogo from "../../../assets/images/ddlogo.png"
import FairwayLogo from "../../../assets/images/fairwaysvg.svg"
import RCMLogo from "../../../assets/images/RCMC_white.svg"
import GladjeLogo from "../../../assets/images/gladje_logo.png"
import GoldstarLogo from "../../../assets/images/goldstar_v2.webp"
import Enterprise from "../../../assets/images/enterprise.svg"
import Disability from "../../../assets/images/disability.svg"

let works = [
  {
    companyName: "RC Mathews",
    background: "#0E171E",
    logo: RCMLogo,
    url: "https://rcmathews.com/",
  },
    {
    companyName: "Gladje",
    background: "#323a69",
    logo: GladjeLogo,
    url: "https://gladjegallery.com/",
  },
  {
    companyName: "Enterprise Solutions",
    background: "#00213B",
    logo: Enterprise,
    url: "https://enterprisellc.com/",
  },
  {
    companyName: "Goldstar Printworks",
    background: "#2c5dd8",
    logo: GoldstarLogo,
    url: "https://goldstarprintworks.com/",
  },
    {
    companyName: "Disability Rights TN",
    background: "#ffffff",
    logo: Disability,
    url: "https://www.disabilityrightstn.org/",
  },

  {
    companyName: "Leisure Leigh Travel",
    background: "#073452",
    logo: LLLogo,
    url: "https://leisureleightravel.com/",
  },
  {
    companyName: "Fairway Lawns",
    background: "#fff",
    logo: FairwayLogo,
    url: "https://fairwaylawns.com/",
  },
  {
    companyName: "Wired Human",
    background: "#272E3E",
    logo: WiredHumanLogo,
    url: "https://wiredhuman.org/",
  },
  {
    companyName: "Serenity at Swan",
    background: "#0F2C42",
    logo: SwanLogo,
    url: "https://serenityatswan.com/",
  },
  {
    companyName: "Florida College",
    background: "#c41230",
    logo: FCLogo,
    url: "https://floridacollege.edu/",
  },
  {
    companyName: "West Business Interiors",
    background: "#F6F5F3",
    logo: WestBusinessLogo,
    url: "https://westinteriors.com/",
  },
  {
    companyName: "Immigration Group",
    background: "#091F40",
    logo: ImmigrationGroupLogo,
    url: "https://immigrationgrp.com/",
  },
  {
    companyName: "Chartwell Hospitality",
    background: "#003265",
    logo: ChartwellLogo,
    url: "https://www.chartwellhospitality.com/",
  },
  {
    companyName: "Genesis Engineering",
    background: "#1d232c",
    logo: GenesisLogo,
    url: "https://geneng.net/",
  },
  {
    companyName: "NCFL",
    background: "#a5a940",
    logo: NCFLLogo,
    url: "https://familieslearning.org/",
  },
  {
    companyName: "Diamond Mobile Detailing",
    background: "#111111",
    logo: DDLogo,
    url: "https://diamondmobiledetailingmn.com/",
  },
  {
    companyName: "Element 47",
    background: "#F6BF5B",
    logo: e47Logo,
    url: "https://element47.co/",
  },
  {
    companyName: "MSMA",
    background: "#FF5B04",
    logo: MSMALogo,
    url: "https://www.msmachisago.com/",
  },
];

const makeKeys = () => {
  let i = 0;
  works.forEach((work) => {
    work.id = i;
    i++;
  });
};

makeKeys();

export default works;